import { FC, useCallback } from "react";
import { SearchWarehouseItemResponse, getWarehouseById, searchWarehouses } from "../../services/warehouse-service";

import { CSSProperties } from "@mui/styles";
import Selector from "components/Selector";
import localisation from "../../localisation";

export type SelectedWarehouseDetails = {
    id: number;
    name: string;
};

export type WarehouseSelectedCallback = (warehouseDetails: SelectedWarehouseDetails | null) => void;

type WarehouseSelectorProps = {
    onSelected: WarehouseSelectedCallback;
    initialWarehouseId?: number;
    id?: string;
    style?: CSSProperties;
    helperText?: string;
    fieldCompanyId: number;
    numberOfSuggestions?: number;
    required?: boolean;
    isValid?: (isValid: boolean) => void;
};

const WarehouseSelector: FC<WarehouseSelectorProps> = (props) => {
    const { onSelected, required, isValid } = props;

    return (
        <Selector<number, SearchWarehouseItemResponse>
            id={props.id}
            style={props.style}
            initialId={props.initialWarehouseId}
            search={useCallback(
                (searchTerm) =>
                    searchWarehouses({
                        fieldCompanyId: props.fieldCompanyId,
                        name: searchTerm,
                    }),
                [props.fieldCompanyId]
            )}
            getById={getWarehouseById}
            render={useCallback((warehouse) => warehouse.name, [])}
            onSelected={useCallback((warehouse) => onSelected(!warehouse ? null : { id: warehouse.id, name: warehouse.name }), [onSelected])}
            localisation={{
                ...localisation.warehouseSelector,
                helperText: props.helperText,
            }}
            required={required}
            isValid={isValid}
        />
    );
};

export default WarehouseSelector;
